module.exports = __webpack_public_path__ + "img/arrow-down.e28c2636.svg";